import { Button, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import RoutesEnum from '../../components/Routes/rootEnum'
import PlatformBrandedShell from './PlatformBrandedShell'
import messages from './signedOutMessages'

// E8 F8-6 (story 8.6.3): the anonymous landing after RP-initiated logout — Entra returns here via the
// postLogoutRedirectUri (authConfig). Rendered by AppShell at /signed-out; offers a path back to /login.
// Platform-branded (PlatformBrandedShell) so the logout landing matches /login and /signup.
const SignedOutPage = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  return (
    <PlatformBrandedShell>
      <Typography variant='h5' component='h1' textAlign='center'>
        {formatMessage(messages.title)}
      </Typography>
      <Typography variant='body2' color='text.secondary' textAlign='center'>
        {formatMessage(messages.subtitle)}
      </Typography>
      <Button variant='contained' size='large' fullWidth onClick={() => navigate(RoutesEnum.LOGIN)}>
        {formatMessage(messages.signInAgain)}
      </Button>
    </PlatformBrandedShell>
  )
}

export default SignedOutPage
